import React from 'react'
import { createRoot } from 'react-dom/client'
import MainView from './main'
import { getLanguage } from 'lib/params'

const rootElement = document.getElementById('mount')
const language = getLanguage()

const root = createRoot(rootElement)
root.render(<MainView language={language} />)
